import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfigService } from '@app/app-config.service';
import { AppStore } from '@app/app.store';
import {
  ContentContainerState,
  ContentContainerStore,
  MainBarState,
  MenuState,
  SidenavState
} from '@app/core/containers/content-container/store/content-container.store';
import { SidenavService } from '@app/core/services/container/sidenav.service';
import { LoginSamlService } from '@app/features/auth/services/login.saml.service';
import { LoginService } from '@app/features/auth/services/login.service';
import { LoginStateService } from '@app/features/auth/services/login.state.service';
import { StoreContainer } from '@app/shared/pages/store-container.component';
import { Subscription } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'vfs-content-container',
  templateUrl: './content-container.component.html',
  styleUrls: ['./content-container.component.scss']
})
export class ContentContainerComponent extends StoreContainer<ContentContainerState, ContentContainerStore>
  implements OnInit, AfterViewInit, OnDestroy {
  menuState: MenuState;
  mainBarState: MainBarState;
  // Sidenav
  sidenavState: SidenavState;
  @ViewChild('dropdown') dropdown: MatSidenav;
  routerEvents: Subscription;

  constructor(
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    @Inject('ContentContainerStore') store: ContentContainerStore,
    appStore: AppStore,
    @Inject('LoginService') protected loginService: LoginService,
    @Inject('LoginStateService') protected loginStateService: LoginStateService,
    protected appConfigService: AppConfigService,
    protected router: Router,
    protected sidenavService: SidenavService,
    @Inject('LoginSamlService') protected loginSamlService: LoginSamlService
  ) {
    super(store, appStore);
    this.store.state$
      .pipe(
        takeUntil(this.destroyed),
        map(menuState => menuState.menu)
      )
      .subscribe(menuState => (this.menuState = menuState));
    this.store.state$
      .pipe(
        takeUntil(this.destroyed),
        map(mainBarState => mainBarState.mainBar)
      )
      .subscribe(mainBarState => (this.mainBarState = mainBarState));
    this.store.state$
      .pipe(
        takeUntil(this.destroyed),
        map(state => state.sidenav)
      )
      .subscribe(sidenavState => (this.sidenavState = sidenavState));
    this.store.state$
      .pipe(
        takeUntil(this.destroyed),
        map(mainBarState => mainBarState.mainBar)
      )
      .subscribe(mainBarState => (this.mainBarState = mainBarState));
    this.store.setMenuItems(this.route.snapshot.data.menu);
    this.store.setMenuExpanded(false);
  }

  ngOnInit() {
    this.routerEvents = this.router.events
      .pipe(
        tap(_ => {
          this.sidenavService.closeSidenav();
        })
      )
      .subscribe();
  }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges(); // FIXME: Change this changes forced
  }

  toggleMenu() {
    this.store.toggleMenu();
  }

  logout() {
    if (this.appConfigService.isAdfsActive()) {
      this.loginService.logoutSSO(this.loginStateService.getSession().user.username).subscribe({
        next: _ => {
          this.store.sidenavState.opened = false;
          this.loginSamlService.redirect();
          this.loginStateService.closeSession();
        },
        error: error => {
          this.loginStateService.setError(error.error);
          this.loginSamlService.redirect();
          this.loginStateService.closeSession();
        }
      });
    } else {
      this.loginService.logout(this.loginStateService.getSession().user.username).subscribe({
        next: _ => {
          this.store.sidenavState.opened = false;
          this.router.navigate(['/auth/login']);
          this.loginStateService.closeSession();
        },
        error: error => {
          this.loginStateService.setError(error.error);
          this.router.navigate(['/auth/login']);
          this.loginStateService.closeSession();
        }
      });
    }
  }

  closedSidenav() {
    this.sidenavState.opened = false;
  }

  openSidenav(template?: TemplateRef<any>) {
    this.store.sidenavState = {
      opened: true,
      template,
      disableClose: true
    };
  }

  closeDropdown() {
    this.dropdown.close();
    this.store.sidenavState = {
      opened: false,
      template: null,
      disableClose: false
    };
  }

  ngOnDestroy() {
    if (this.routerEvents) {
      this.routerEvents.unsubscribe();
    }
  }
}
